import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom, type Observable } from 'rxjs';
import { environment } from 'environments/environment';
import { BaseService } from '../../core';
import { ExtraiTextoArquivoRequest } from '../edducai/request/extrai-contrato-analise.request';
import { ArquivoResponse } from 'app/shared/models/ei-models';

@Injectable({ providedIn: 'root' })
export class ArquivoService extends BaseService {
  private ArquivoEndpoint = `${environment.urlEdducaImobApi}EdducaImobCore/Arquivo/`;

  constructor(private http: HttpClient) {
    super();
  }

  upload(file: File, idUsuario: number): Observable<ArquivoResponse> {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post<ArquivoResponse>(`${this.ArquivoEndpoint}Upload/${idUsuario}`, formData);
  }

listarArquivos(): Observable<Array<ArquivoResponse>> {
    return this.http.get<Array<ArquivoResponse>>
        (this.ArquivoEndpoint.concat('ListarArquivos'), { headers: this.getHeader(true) });
}

  async extraiTextoArquivo(base64Pdf: ExtraiTextoArquivoRequest): Promise<string> {
    return await firstValueFrom(
      this.http.post(`${this.ArquivoEndpoint}ExtraiTextoArquivo`, base64Pdf, {
        headers: this.getHeader(true),
        responseType: 'text' as const
      })); 
  }
}
